"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var s = _interopRequireWildcard(require("./TooltipPopup.style"));

var _HoverAccentButton = _interopRequireDefault(require("../Button/HoverAccentButton"));

/* eslint-disable react/no-danger */
var Popup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popup, _React$Component);

  function Popup() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Popup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Popup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getTitle", function () {
      var title = _this.props.title;

      if (_react.default.isValidElement(title)) {
        return title;
      } else if (typeof title === 'function') {
        return title();
      }

      return title;
    });
    return _this;
  }

  (0, _createClass2.default)(Popup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          popupref = _this$props.popupref,
          theme = _this$props.theme,
          show = _this$props.show,
          animate = _this$props.animate,
          top = _this$props.top,
          left = _this$props.left,
          hideArrow = _this$props.hideArrow,
          arrowPlacement = _this$props.arrowPlacement,
          arrowCoords = _this$props.arrowCoords,
          showCross = _this$props.showCross,
          hideToolTip = _this$props.hideToolTip,
          className = _this$props.className,
          overlayClassName = _this$props.overlayClassName;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: (0, _classnames.default)(s.popupBody({
          show: show,
          animate: animate,
          theme: theme,
          top: top,
          left: left,
          hideArrow: hideArrow,
          arrowPlacement: arrowPlacement,
          arrowCoords: arrowCoords
        }), className),
        ref: popupref
      }, this.getTitle(), showCross ? _react.default.createElement(_HoverAccentButton.default, {
        icon: {
          type: 'close',
          className: s.closeIcon,
          style: {
            width: 12,
            height: 12
          }
        },
        onClick: hideToolTip,
        className: s.closeIconButton
      }) : null), overlayClassName && show ? _react.default.createElement("div", {
        className: (0, _classnames.default)(s.overlay, overlayClassName),
        onClick: hideToolTip,
        tabIndex: "0",
        role: "button"
      }) : null);
    }
  }]);
  return Popup;
}(_react.default.Component);

var _default = Popup;
exports.default = _default;